import { CopyButton } from "@/components/ui/CopyButton";

interface CopyMrnButtonProps {
  mrn: string;
  testId?: string;
}

export function CopyMrnButton({ mrn, testId }: CopyMrnButtonProps) {
  return (
    <CopyButton
      text={mrn}
      tooltip="Copy MRN"
      successText="MRN copied"
      testId={testId}
    />
  );
}
